import { createApi } from '@reduxjs/toolkit/query/react';

import { createApiBaseQuery, Methods } from '@app/api/shared';
import {
  UserFileRequestsEndpoints as Endpoints,
  type DownloadFileRequestRequest,
  type DownloadFileRequestResponse,
  type GetFileRequestInfoRequest,
  type GetFileRequestInfoResponse,
  type StartFileRequestClientsRequest,
  type StartFileRequestClientsResponse,
  type StartFileRequestRecordsRequest,
  type StartFileRequestRecordsResponse,
  type TestFileRequestClientsRequest,
  type TestFileRequestClientsResponse,
  type TestFileRequestRecordsRequest,
  type TestFileRequestRecordsResponse,
} from '@app/api/UserFileRequests/types';
import { USER_FILE_REQUESTS } from '@app/constants';

export const userFileRequestsApi = createApi({
  reducerPath: 'userFileRequestsApi',
  baseQuery: createApiBaseQuery(USER_FILE_REQUESTS),
  endpoints: ({ mutation, query }) => ({
    [Endpoints.TestFileRequestClients]: query<
      TestFileRequestClientsResponse,
      TestFileRequestClientsRequest
    >({
      query: (params) => ({
        url: Endpoints.TestFileRequestClients,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.StartFileRequestClients]: mutation<
      StartFileRequestClientsResponse,
      StartFileRequestClientsRequest
    >({
      query: (params) => ({
        url: Endpoints.StartFileRequestClients,
        method: Methods.POST,
        params,
      }),
    }),
    [Endpoints.GetFileRequestInfo]: query<
      GetFileRequestInfoResponse,
      GetFileRequestInfoRequest
    >({
      query: (params) => ({
        url: Endpoints.GetFileRequestInfo,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.DownloadFileRequest]: query<
      DownloadFileRequestResponse,
      DownloadFileRequestRequest
    >({
      query: (params) => ({
        url: Endpoints.DownloadFileRequest,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.TestFileRequestRecords]: query<
      TestFileRequestRecordsResponse,
      TestFileRequestRecordsRequest
    >({
      query: (params) => ({
        url: Endpoints.TestFileRequestRecords,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.StartFileRequestRecords]: mutation<
      StartFileRequestRecordsResponse,
      StartFileRequestRecordsRequest
    >({
      query: (params) => ({
        url: Endpoints.StartFileRequestRecords,
        method: Methods.POST,
        params,
      }),
    }),
  }),
});

export const {
  useTestFileRequestClientsQuery,
  useLazyTestFileRequestClientsQuery,
  useStartFileRequestClientsMutation,
  useGetFileRequestInfoQuery,
  useLazyGetFileRequestInfoQuery,
  useDownloadFileRequestQuery,
  useLazyDownloadFileRequestQuery,
  useTestFileRequestRecordsQuery,
  useLazyTestFileRequestRecordsQuery,
  useStartFileRequestRecordsMutation,
} = userFileRequestsApi;
